export enum Theme {
	LIGHT = "light-theme",
	DARK = "dark-theme",
}

export enum ThemeEnabledOptions{
	YES = 'Yes',
	NO = 'No'
}